import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, forwardRef, Input, OnChanges, ViewEncapsulation, Injector, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { LeadSystemStage, LeadSystemStages } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'lead-stage-picker',
    templateUrl: './stage.picker.component.html',
    styleUrls: ['./stage.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LeadStagePickerComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeadStagePickerComponent extends PickerBaseComponent implements OnChanges {

    @Input() public data: LeadSystemStage[];
    @Input() public placeholder = '<Lead Stage>';
    @Input() public multiple = false;
    @Input() public allowClear = false;
    @Input() public appendTo;
    @Input() public selectableGroup = false;
    @Input() public allowClose = true;

    public data$: Observable<LeadSystemStage[]>;
    public PickerItemStyle = PickerItemStyle;

    constructor(
        cdr: ChangeDetectorRef,
        injector: Injector,
        private http: HttpClient
    ) {
        super(injector);
    }

    public ngOnChanges() {

        this.data$ = this.fetch === PickerFetch.Automatic
            ? this.getLabels()
            : of(this.data);

    }

    private getLabels(): Observable<LeadSystemStage[]> {
        return of(LeadSystemStages)
    }


}

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgSelectModule,
        PickerItemModule,
    ],
    declarations: [
        LeadStagePickerComponent
    ],
    providers: [],
    exports: [
        LeadStagePickerComponent
    ],
})
export class LeadStagePickerModule { }
